module.exports = __webpack_public_path__ + "img/identity_card_bg.aa5ede5b.png";